module.exports = __webpack_public_path__ + "static/media/solutions-icon-4.319fd5cf.svg";